import React from 'react';
import { Select } from 'antd';
import { v4 as uuid } from 'uuid';
import { message } from 'components/common';
import { getProductUomList } from 'services/product'

type Props = {
  onChange?: Function;
  sku: string;
};

const UomSelector = (props: Props) => {
  const { useState } = React;
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState<StringKAnyVPair[]>([]);
  const [sku, setSku] = useState<string>();
  const [value, setValue] = useState();

  const loadUomList = async (sku: string) => {
    setIsLoading(true);

    try {
      const { data } = await getProductUomList(sku);

      if (Array.isArray(data)) {
        //console.log('r', data);
        const opts = data.map(u => ({
          value: uuid(),
          label: `${u.uom}(${u.uomRate})`,
          uom: u.uom,
          uomrate: u.uomRate,
        }));
        setOptions(opts);
      }
    } catch(e) {
      //console.log(`Loading UOM list error: ${e}`);
      message.error({ content: `Loading UOM list error: ${e}` });
    } finally {
      setIsLoading(false);
    }
  };

  const onChange = (val: any) => {
    const opt = options.find(e => e.value === val);

    //console.log(opt, '<-');
    if (props.onChange) props.onChange(opt);
  };

  React.useEffect(() => {
    if (sku !== props.sku) {
      //console.log('p', props);
      loadUomList(props.sku);
      setSku(props.sku);
      setValue(undefined);
    }
  }, [props, sku]);

  return (<>
    <Select
      allowClear
      loading={isLoading}
      onChange={onChange}
      options={options}
      value={value}
    />
  </>);
};

export default UomSelector;
